<template>
  <el-cascader
    class="cascader"
    ref="cascaderAddr"
    :rules="[
      { required: isNeedVail, message: '请输入地址', trigger: 'blur, change' },
      /* { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' } */
    ]"
    v-model="subAreaList"
    :disabled="isDisabled"
    :options="options"
    :props="propsCfig"
    filterable
    @change="handleChange"/>
</template>

<script>
let self = this;
export default {
  props: {
    areaList: {
      type: Array,
      default: () => []
    },
    isNeedVail: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    areaList: {
      handler: function (n, o) {
        this.subAreaList = n;
        console.log('test=>>', n);
      },
      // deep: true
      immediate: true
    }
  },
  data() {
    return {
      options: [],
      subAreaList: [],
      propsCfig: {
        label: 'areaName',
        value: 'areaCode',
        children: 'children',
        expandTrigger: 'hover'
      }
    }
  },
  mounted() {
    self = this;
    self.getAreaList();
  },
  methods: {
    getAreaList() {
      self.$https.get('/system/area/tree', {areaLevel: self.areaLevel}).then(res => {
        if (res.code == 200) {
          self.options = res.data || [];
        }
        // console.log(res);
      }).catch(res => {

      });
    },
    handleChange(value) {
      setTimeout(() => {
        console.log(this.$refs["cascaderAddr"].inputValue)
        // this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels
        self.$emit('getAreaData', {
          codes: value,
          names: this.$refs["cascaderAddr"].inputValue.replace(/\s+/g,"").split('/')
        })
      }, 300)
    },
    // validateForm () {
    //   let flag = null
    //   this.$refs.cascaderAddr.validate(valid => {
    //     if (valid) {
    //       flag = true
    //     } else {
    //       flag = false
    //     }
    //   })
    //   return flag
    // }
  },
}
</script>

<style lang="less" scoped>
  .cascader {
    width: 100%;
  }
</style>
